import { all, fork } from "redux-saga/effects";
import authSaga from "./auth/saga";
import usersMasterSaga from "./users/saga";
import homesMasterSaga from "./home/saga";
import subservicesMasterSaga from "./subservices/saga";
import contactMasterSaga from "./contactus/saga";
import faqsMasterSaga from "./faq/saga";
import marketingsMasterSaga from "./marketing/saga";
import giftsMasterSaga from "./giftcards/saga";
import restaurantMasterSaga from "./restaurant/saga";
import communityMasterSaga from "./community/saga";
import eventsManagementMasterSaga from "./eventmanagement/saga";
import dishesMasterSaga from "./dishes/saga";
import slotsMasterSaga from "./slots/saga";
import adddishMasterSaga from "./adddish/saga";
import discountFilterMasterSaga from "./discountfilter/saga";
import cuisinesMasterSaga from "./cuisines/saga";

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(usersMasterSaga),
    fork(cuisinesMasterSaga),
    fork(homesMasterSaga),
    fork(subservicesMasterSaga),
    fork(faqsMasterSaga),
    fork(contactMasterSaga),
    fork(marketingsMasterSaga),
    fork(giftsMasterSaga),
    fork(restaurantMasterSaga),
    fork(communityMasterSaga),
    fork(eventsManagementMasterSaga),
    fork(dishesMasterSaga),
    fork(slotsMasterSaga),
    fork(adddishMasterSaga),
    fork(discountFilterMasterSaga),
  ]);
}
